/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfEditableMenuHelpsDto } from '../models/custom-result-of-editable-menu-helps-dto';
import { CustomResultOfGetMenuByTitleDto } from '../models/custom-result-of-get-menu-by-title-dto';
import { CustomResultOfListOfKeyValuePairOfIntegerAndString } from '../models/custom-result-of-list-of-key-value-pair-of-integer-and-string';
import { CustomResultOfListOfMenuDto } from '../models/custom-result-of-list-of-menu-dto';
import { CustomResultOfPaginatedListOfMenuListItemDto } from '../models/custom-result-of-paginated-list-of-menu-list-item-dto';
import { CustomResultOfUpdateMenuCommand } from '../models/custom-result-of-update-menu-command';
import { menusCreateGet } from '../fn/menus/menus-create-get';
import { MenusCreateGet$Params } from '../fn/menus/menus-create-get';
import { menusCreatePost } from '../fn/menus/menus-create-post';
import { MenusCreatePost$Params } from '../fn/menus/menus-create-post';
import { menusDelete } from '../fn/menus/menus-delete';
import { MenusDelete$Params } from '../fn/menus/menus-delete';
import { menusGetAsideMenus } from '../fn/menus/menus-get-aside-menus';
import { MenusGetAsideMenus$Params } from '../fn/menus/menus-get-aside-menus';
import { menusGetMenuById } from '../fn/menus/menus-get-menu-by-id';
import { MenusGetMenuById$Params } from '../fn/menus/menus-get-menu-by-id';
import { menusGetMenuByTitle } from '../fn/menus/menus-get-menu-by-title';
import { MenusGetMenuByTitle$Params } from '../fn/menus/menus-get-menu-by-title';
import { menusGetMenusAudit } from '../fn/menus/menus-get-menus-audit';
import { MenusGetMenusAudit$Params } from '../fn/menus/menus-get-menus-audit';
import { menusGetMenusWithPagination } from '../fn/menus/menus-get-menus-with-pagination';
import { MenusGetMenusWithPagination$Params } from '../fn/menus/menus-get-menus-with-pagination';
import { menusGetTreeMenus } from '../fn/menus/menus-get-tree-menus';
import { MenusGetTreeMenus$Params } from '../fn/menus/menus-get-tree-menus';
import { menusUpdateGet } from '../fn/menus/menus-update-get';
import { MenusUpdateGet$Params } from '../fn/menus/menus-update-get';
import { menusUpdateMenuHelpsGet } from '../fn/menus/menus-update-menu-helps-get';
import { MenusUpdateMenuHelpsGet$Params } from '../fn/menus/menus-update-menu-helps-get';
import { menusUpdateMenuHelpsPut } from '../fn/menus/menus-update-menu-helps-put';
import { MenusUpdateMenuHelpsPut$Params } from '../fn/menus/menus-update-menu-helps-put';
import { menusUpdatePut } from '../fn/menus/menus-update-put';
import { MenusUpdatePut$Params } from '../fn/menus/menus-update-put';
import { menusUploadHelpFiles } from '../fn/menus/menus-upload-help-files';
import { MenusUploadHelpFiles$Params } from '../fn/menus/menus-upload-help-files';

@Injectable({ providedIn: 'root' })
export class MenusService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `menusGetMenusAudit()` */
  static readonly MenusGetMenusAuditPath = '/Menus/GetMenusAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetMenusAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusGetMenusAudit$Response(params: MenusGetMenusAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return menusGetMenusAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetMenusAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusGetMenusAudit(params: MenusGetMenusAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.menusGetMenusAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `menusGetAsideMenus()` */
  static readonly MenusGetAsideMenusPath = '/Menus/GetAsideMenus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetAsideMenus()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetAsideMenus$Response(params?: MenusGetAsideMenus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfMenuDto>> {
    return menusGetAsideMenus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetAsideMenus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetAsideMenus(params?: MenusGetAsideMenus$Params, context?: HttpContext): Observable<CustomResultOfListOfMenuDto> {
    return this.menusGetAsideMenus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfMenuDto>): CustomResultOfListOfMenuDto => r.body)
    );
  }

  /** Path part for operation `menusGetMenusWithPagination()` */
  static readonly MenusGetMenusWithPaginationPath = '/Menus/GetMenusWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetMenusWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusGetMenusWithPagination$Response(params: MenusGetMenusWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfMenuListItemDto>> {
    return menusGetMenusWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetMenusWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusGetMenusWithPagination(params: MenusGetMenusWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfMenuListItemDto> {
    return this.menusGetMenusWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfMenuListItemDto>): CustomResultOfPaginatedListOfMenuListItemDto => r.body)
    );
  }

  /** Path part for operation `menusGetTreeMenus()` */
  static readonly MenusGetTreeMenusPath = '/Menus/GetTreeMenus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetTreeMenus()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetTreeMenus$Response(params?: MenusGetTreeMenus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>> {
    return menusGetTreeMenus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetTreeMenus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetTreeMenus(params?: MenusGetTreeMenus$Params, context?: HttpContext): Observable<CustomResultOfListOfKeyValuePairOfIntegerAndString> {
    return this.menusGetTreeMenus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>): CustomResultOfListOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

  /** Path part for operation `menusGetMenuById()` */
  static readonly MenusGetMenuByIdPath = '/Menus/GetMenuById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetMenuById()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetMenuById$Response(params: MenusGetMenuById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUpdateMenuCommand>> {
    return menusGetMenuById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetMenuById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetMenuById(params: MenusGetMenuById$Params, context?: HttpContext): Observable<CustomResultOfUpdateMenuCommand> {
    return this.menusGetMenuById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUpdateMenuCommand>): CustomResultOfUpdateMenuCommand => r.body)
    );
  }

  /** Path part for operation `menusGetMenuByTitle()` */
  static readonly MenusGetMenuByTitlePath = '/Menus/GetMenuByTitle/{title}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusGetMenuByTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetMenuByTitle$Response(params: MenusGetMenuByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetMenuByTitleDto>> {
    return menusGetMenuByTitle(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusGetMenuByTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusGetMenuByTitle(params: MenusGetMenuByTitle$Params, context?: HttpContext): Observable<CustomResultOfGetMenuByTitleDto> {
    return this.menusGetMenuByTitle$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetMenuByTitleDto>): CustomResultOfGetMenuByTitleDto => r.body)
    );
  }

  /** Path part for operation `menusCreateGet()` */
  static readonly MenusCreateGetPath = '/Menus/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusCreateGet$Response(params?: MenusCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return menusCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusCreateGet(params?: MenusCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.menusCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `menusCreatePost()` */
  static readonly MenusCreatePostPath = '/Menus/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusCreatePost$Response(params: MenusCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return menusCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusCreatePost(params: MenusCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.menusCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `menusUpdatePut()` */
  static readonly MenusUpdatePutPath = '/Menus/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusUpdatePut$Response(params: MenusUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return menusUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusUpdatePut(params: MenusUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.menusUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `menusUpdateGet()` */
  static readonly MenusUpdateGetPath = '/Menus/Update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusUpdateGet$Response(params: MenusUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUpdateMenuCommand>> {
    return menusUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusUpdateGet(params: MenusUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfUpdateMenuCommand> {
    return this.menusUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUpdateMenuCommand>): CustomResultOfUpdateMenuCommand => r.body)
    );
  }

  /** Path part for operation `menusDelete()` */
  static readonly MenusDeletePath = '/Menus/Delete/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusDelete$Response(params: MenusDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return menusDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusDelete(params: MenusDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.menusDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `menusUploadHelpFiles()` */
  static readonly MenusUploadHelpFilesPath = '/Menus/UploadHelpFiles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusUploadHelpFiles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  menusUploadHelpFiles$Response(params?: MenusUploadHelpFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return menusUploadHelpFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusUploadHelpFiles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  menusUploadHelpFiles(params?: MenusUploadHelpFiles$Params, context?: HttpContext): Observable<CustomResult> {
    return this.menusUploadHelpFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `menusUpdateMenuHelpsGet()` */
  static readonly MenusUpdateMenuHelpsGetPath = '/Menus/UpdateMenuHelps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusUpdateMenuHelpsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusUpdateMenuHelpsGet$Response(params?: MenusUpdateMenuHelpsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfEditableMenuHelpsDto>> {
    return menusUpdateMenuHelpsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusUpdateMenuHelpsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusUpdateMenuHelpsGet(params?: MenusUpdateMenuHelpsGet$Params, context?: HttpContext): Observable<CustomResultOfEditableMenuHelpsDto> {
    return this.menusUpdateMenuHelpsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfEditableMenuHelpsDto>): CustomResultOfEditableMenuHelpsDto => r.body)
    );
  }

  /** Path part for operation `menusUpdateMenuHelpsPut()` */
  static readonly MenusUpdateMenuHelpsPutPath = '/Menus/UpdateMenuHelps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusUpdateMenuHelpsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusUpdateMenuHelpsPut$Response(params: MenusUpdateMenuHelpsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return menusUpdateMenuHelpsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusUpdateMenuHelpsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  menusUpdateMenuHelpsPut(params: MenusUpdateMenuHelpsPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.menusUpdateMenuHelpsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
